import { Guard, type GuardRun } from '../utils/Guard';
import { isValidToAccessToPowerUp } from '$utils/isValidToAccessToPowerUp';

export class AccessCirclesPowerUp extends Guard implements GuardRun {
  run() {
    if (!isValidToAccessToPowerUp()) {
      return this.cancel();
    }
  }
}
